export const LANDING_PAGE_URL = "https://rolexx9.bet/RFLANDIINGPAGE";

